import AltSR from '../generic/AltSR';
import type { FormattedNumber } from '../model/types';
import * as style from './VolumeAndPrice.module.css';

export default function VolumeAndPrice({ volume, price, pricePrefix }: { volume?: FormattedNumber; price: FormattedNumber; pricePrefix?: string }) {
    return (
        <div className={style.priceAndVolume}>
            <div className={style.price}>
                <AltSR text={price.formattedValue} sr={pricePrefix + price.readableValue} />
            </div>
            <div className={style.volume}>
                <AltSR text={volume?.formattedValue} sr={volume?.readableValue} />
            </div>
        </div>
    );
}
